(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!window.mpBuyNowInit) {
  window.mpBuyNowInit = true;
  document.addEventListener('variant:selected', function (event) {
    var section = event.target.closest('.shopify-section');
    if (!section) return;
    section.dataset.mpVariantPending = 'true';
    section.querySelectorAll('[data-mp-buy-now]').forEach(function (button) { button.disabled = true; });
    section.querySelectorAll('[data-mp-whatsapp-order]').forEach(function (link) { link.setAttribute('aria-disabled', 'true'); });
  });
  document.addEventListener('variant:update', function (event) {
    var section = event.target.closest('.shopify-section');
    var html = event.detail && event.detail.data && event.detail.data.html;
    if (!section || !html) return;
    delete section.dataset.mpVariantPending;
    var freshQuantity = html.querySelector('product-form-component input[name="quantity"]');
    section.querySelectorAll('product-form-component input[name="quantity"]').forEach(function (input) {
      input.disabled = !event.detail.resource || !event.detail.resource.available || !!freshQuantity?.disabled;
    });
    section.querySelectorAll('[data-mp-buy-now]').forEach(function (button) {
      var fresh = html.querySelector('[data-mp-buy-now]');
      button.disabled = !event.detail.resource || !event.detail.resource.available || !fresh || fresh.disabled;
    });
    ['[data-mp-overview]', '[data-mp-contact]'].forEach(function (selector) {
      section.querySelectorAll(selector).forEach(function (current) {
        var fresh = Array.from(html.querySelectorAll(selector)).find(function (node) {
          return node.dataset.mpBlock === current.dataset.mpBlock;
        });
        if (fresh) current.replaceWith(fresh.cloneNode(true));
      });
    });
    if (!event.detail.resource) {
      section.querySelectorAll('[data-mp-whatsapp-order]').forEach(function (link) {
        link.dataset.available = 'false';
        link.dataset.variantId = '';
        link.dataset.variant = Array.from(section.querySelectorAll('variant-picker input:checked, variant-picker option:checked')).map(function (option) { return option.value; }).join(' / ');
        link.dataset.usdt = '';
        link.dataset.usdCents = ''; 
        var label = link.querySelector('[data-mp-wa-label]');
        if (label) label.textContent = link.dataset.consultLabel;
      });
    }
  });
  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-mp-buy-now]');
    if (!button || button.disabled) return;
    event.preventDefault();
    var component = button.closest('product-form-component');
    var form = component && component.querySelector('form[data-type="add-to-cart-form"]');
    var section = button.closest('.shopify-section');
    var nativeButton = component && component.querySelector('[ref="addToCartButton"]');
    if (!form || section?.dataset.mpVariantPending || nativeButton?.disabled || !form.reportValidity()) return;
    var quantitySelector = component.querySelector('quantity-selector-component');
    var quantityCheck = quantitySelector?.canAddToCart?.();
    var status = component.querySelector('[ref="liveRegion"]');
    var errorBox = component.querySelector('[data-mp-purchase-error]');
    if (quantityCheck && !quantityCheck.canAdd) {
      if (errorBox) { errorBox.textContent = button.dataset.error; errorBox.hidden = false; }
      if (status) status.textContent = button.dataset.error;
      return;
    }
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = button.dataset.processing;
    if (errorBox) errorBox.hidden = true;
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 15000);
    try {
      var data = new FormData(form);
      if (!data.get('id')) throw new Error(button.dataset.error);
      var quantityInput = form.querySelector('[name="quantity"]');
      data.set('quantity', quantityInput?.value || component.dataset.quantityDefault || '1');
      var root = window.Shopify?.routes?.root || '/';
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST', body: data, headers: { Accept: 'application/json' }, signal: controller.signal
      });
      if (!response.ok) {
        var detail = await response.json().catch(function () { return {}; });
        throw new Error(detail.description || detail.message || button.dataset.error);
      }
      window.location.assign(root + 'checkout');
    } catch (error) {
      var message = error.name === 'AbortError' ? button.dataset.error : error.message || button.dataset.error;
      if (status) status.textContent = message;
      if (errorBox) { errorBox.textContent = message; errorBox.hidden = false; }
      button.textContent = button.dataset.label;
      button.disabled = !!nativeButton?.disabled || !!section?.dataset.mpVariantPending;
    } finally {
      clearTimeout(timeout);
      button.removeAttribute('aria-busy');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mp-product-contact"] && !Shopify.designMode) return;
  try {
    if (!window.mpWhatsappOrderInit) {
  window.mpWhatsappOrderInit = true;
  var mpUpdateWhatsappLink = function (event) {
    var link = event.target.closest('[data-mp-whatsapp-order]');
    if (!link && event.type !== 'click') link = event.target.closest('.shopify-section')?.querySelector('[data-mp-iphone-whatsapp]');
    if (!link) return;
    if (link.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
    var productRoot = link.closest('.shopify-section') || link.closest('.product-information') || document;
    var quantityInput = productRoot.querySelector('input[name="quantity"]');
    var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);
    var cents = Number(link.dataset.usdCents);
    var hasPrice = link.dataset.usdCents !== '' && Number.isSafeInteger(cents) && cents >= 0 && link.dataset.currency === 'USD';
    var usd = cents / 100;
    var rateText = link.dataset.rate;
    var rate = Number(rateText);
    var hasRate = /^\d+(?:\.\d{1,9})?$/.test(rateText) && Number.isFinite(rate) && rate > 0;
    var format = function (amount) {
      return new Intl.NumberFormat('es-BO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
    };
    var bobTotal = function (quantity) {
      var parts = rateText.split('.');
      var decimals = parts[1] || '';
      var divisor = 10n ** BigInt(decimals.length);
      var numerator = BigInt(cents) * BigInt(parts[0] + decimals) * BigInt(quantity);
      return Number((numerator + divisor / 2n) / divisor) / 100;
    };
    var available = link.dataset.available === 'true';
    var variantUrl = new URL(link.dataset.productUrl);
    if (link.hasAttribute('data-mp-iphone-whatsapp')) {
      variantUrl = new URL(variantUrl.pathname, 'https://tienda.movilplus.bo');
    }
    if (link.dataset.variantId) variantUrl.searchParams.set('variant', link.dataset.variantId);
    var unitPrice = hasPrice
      ? '*' + link.dataset.price + ': ' + format(usd) + ' USDT' + (hasRate ? ' / Bs. ' + format(bobTotal(1)) : '') + '*'
      : '*' + link.dataset.price + ': ' + link.dataset.unknown + '*';
    var total = hasPrice
      ? '*' + link.dataset.total + ': ' + format(usd * quantity) + ' USDT' + (hasRate ? ' / Bs. ' + format(bobTotal(quantity)) : '') + '*'
      : '*' + link.dataset.total + ': ' + link.dataset.unknown + '*';
    var rateLine = hasRate ? link.dataset.rateLabel + ' ' + format(rate) + ' Bs./USDT' : link.dataset.noRate;
    var message = [

      '¡Hola Móvil Plus! 👋',
      available ? link.dataset.intro : link.dataset.consult,
      '',
      quantity + 'x ' + link.dataset.product + (link.dataset.variant ? ' — ' + link.dataset.variant : ''),
      unitPrice,
      rateLine,
      '',
      variantUrl.href,
      '-----------------------------------',
      total,
      link.dataset.checkoutNotice,
      '',
      available ? link.dataset.closing : ''
    ].join('\n');
    link.href = 'https://wa.me/' + link.dataset.phone + '?text=' + encodeURIComponent(message);
  };
  document.addEventListener('click', mpUpdateWhatsappLink, true);
  document.addEventListener('input', function (event) {
    if (event.target.matches('input[name="quantity"]')) mpUpdateWhatsappLink(event);
  });
  document.addEventListener('variant:update', function (event) {
    queueMicrotask(function () { mpUpdateWhatsappLink(event); });
  });
}
  } catch(e) { console.error(e); }
})();

})();
